import React, { useEffect, useCallback, useState } from 'react';
import { Toast } from 'antd-mobile'
import Clipboard from 'clipboard'

import {useUrlQuery} from '../../utils/useFunc'
import req from '../../utils/req'
// import headImg from '../../assets/img/r_s.png'
import style from './style.module.css';
// import {useUrlQuery} from '../../utils/useFunc';
import img1 from '../../assets/img/payment_successful.jpg';
import imgButton from '../../assets/img/down-app.png';
import {computePX} from '../../utils/tool'

// 微信号配置
const useGetwxconfig = (member_id) => {
    // 微信号
    let [wxnum, setWxnum] = useState('')
    // 微信二维码
    let [wxqrcode, setWxqrcode] = useState("")
    let getqrcode = useCallback(async () => {
      if (member_id === undefined) return
      Toast.loading('', 0)
      let data = await req.post("https://service.agent.pro.caixuetang.cn?serviceversion=v1&c=generalizestaff&a=getstaffqrcode&v=user&site=generalizestaff", {
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        appcode: sessionStorage.getItem('appCode')
    })
        Toast.hide()
        if (data.code != 1) {
            Toast.fail(data.message)
            return
        }
        setWxqrcode(data.data.wx_qr_code)
        setWxnum(data.data.wx_num)
    }, [member_id])
    useEffect(() => {
        getqrcode()
    }, [getqrcode])
    return {wxnum, wxqrcode}
}
// 动态计算高度
const useComputeArea = () => {
    let [textTop, setTextTop] = useState(0)
    let [qrcodeTop, setQrcodeTop] = useState(0)
    let [qrcodeArea, setQrcodeArea] = useState(0)
    useEffect(() => {
        let c = computePX(375, window.innerWidth)
        setTextTop(c(280))
        setQrcodeTop(c(350))
        setQrcodeArea(c(165))
    }, [])
    return {textTop, qrcodeTop, qrcodeArea}
}
function appDownloadFunc() {
    // 判断终端，此处也列了一些判断其他终端的方法
    const u = navigator.userAgent
    const ua = navigator.userAgent.toLowerCase()
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (isAndroid) {
      // 调起APP android
      window.location.href = 'android://com.caixuetang.app/open'
    } else if (isiOS) {
      // 调起APP ios
      if (ua.match(/QQ/i) == 'qq') {
        // qq的话
        var a = document.createElement('a')
        a.href = 'QQ41FA1219://'
        a.click()
      } else {
        // window.location.href = 'https://www.caixuetang.cn'
      }
    }
    // 如果超时证明没有安装此APP则跳到下载页
    window.setTimeout(function() {
      var hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
      if (typeof hidden == 'undefined' || hidden == false) {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.caixuetang.app'
      }
    }, 2000)
}
export default () => {
    let {member_id} = useUrlQuery()
    if (!member_id) {
        const member_id = localStorage.getItem('member_id')
        window.location.hash = `#/result?member_id=${member_id}`
        return <div></div>
    }
    if (!member_id) {
        return <div>参数错误</div>
    }
    let {wxnum, wxqrcode} = useGetwxconfig(member_id)
    let {textTop, qrcodeTop, qrcodeArea} = useComputeArea()
    // 点击复制功能
    useEffect(() => {
        console.log(style.copybtn)
        let clipboard = new Clipboard('.' + style.copybtn)
        clipboard.on('success', function(e) {
            Toast.success("复制成功")
            setTimeout(() => {
                window.location = 'weixin://'
            },1000)
        });
        clipboard.on('error', function(e) {
            Toast.fail("复制失败请重试")
        });
    }, [])

    // dom
    let qrcodeDOM = null
    if (wxqrcode) {
        qrcodeDOM = <div className={style.qrcode} style={{top: qrcodeTop + 'px'}}><img alt="二维码" src={wxqrcode} style={{width: qrcodeArea + 'px', height: qrcodeArea + 'px'}}></img></div>
    }
    let wxnumDOM = null
    if (wxnum) {
        wxnumDOM = <p>
            <span>{wxnum}</span>&nbsp;&nbsp;
            <span className={style.copybtn} data-clipboard-text={wxnum}>点击复制</span>
        </p>
    }
    return <div>
        {/* <div className={style.top}><img alt="图片" className={style.head} src={headImg}/></div>
        <div className={style.text}>
            <p className={style['text-1']}>添加班主任微信立即开启畅学之旅~</p>
            <p className={style['text-1']}>新用户限时注册更能免费领取炒股实战包</p>
            <p className={style['text-2']}>好好学财&nbsp;&nbsp;天天向上</p>
        </div>
        <div className={style['qr-code']}>
            <img alt="二维码" src={wxqrcode}/>
            <p>二位码无法识别？请复制微信联系 <span>复制</span></p>
        </div>
        <div className={style.submit}>下载财学堂APP</div> */}
        <div style={{position:'relative'}}>
            <img alt="图片" style={{width: '100%'}} src={img1}></img>
            <div className="box_scale" style={{width: '88%'}} className={style.countDown_btn}>
            <img alt='' style={{width: '100%', position:'absolute',bottom:-10,left:0}} src={imgButton} onClick={() => {
                appDownloadFunc()
            }} />
            </div>
        </div>
        {/* <div className={style.img1}><img alt="背景图片" src={img1}></img></div>
        <div className={style.text} style={{top: textTop + 'px'}}>
            <p>新用户限时注册，现在添加班主任微信</p>
            <a href="https://work.weixin.qq.com/kfid/kfcf01b12484e51cb05" className={style.feedback}>如遇添加不上，点此微信客服反馈</a>
            {/* {wxnumDOM} }
        </div>
        {qrcodeDOM} */}
    </div>
}